import React from 'react'
import * as actionCreators from '../../actions/RouterActions'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import { useDispatch } from 'react-redux'
import { useFirebase, useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import Dropzone from 'react-dropzone';
import * as moment from 'moment'

export default function Lotteryrow(props) {
    moment.locale('de');
    const firebase = useFirebase()
    const [ isUploading, setIsUploading ] = React.useState({});
    const dispatch = useDispatch()

    const state = props.state;
    const lotteryId = state.id;
    const storelocatorDetails = props.storelocatorDetails;

    const sleep = async function(t){
        return new Promise((resolve) => setTimeout(resolve, t));
    }

    const onDrop = (lotteryId, files) => {
        (async () => {
            setIsUploading({...isUploading, loading: true, error: false, success: false, processing: false});

            var uploadResult = null;
            try {
                uploadResult = await firebase.uploadFiles('storelocator/rmf/' + lotteryId, files);
            }catch(e){
                console.log('Error', e);
                setIsUploading({...isUploading, loading: false, error: true, success: false});
            }

            if(uploadResult !== null && Array.isArray(uploadResult) && uploadResult.length > 0){
                setIsUploading({...isUploading, loading: false, error: false, success: false, processing: true});
                let filename = uploadResult[0].uploadTaskSnapshot.metadata.name;
                let result = await firebase.app('').functions('europe-west1').httpsCallable('cms_dev-rmf_import')({lottery: lotteryId, filename: filename});
            }

            await sleep(5000);
            setIsUploading({...isUploading, loading: false, error: false, success: false, processing: false});
        })();
    }
    
    return (
        <Table.Row warning={(storelocatorDetails !== null)?false:true} error={(storelocatorDetails !== null && typeof storelocatorDetails.errors !== 'undefined' && storelocatorDetails.errors > 0)?true:false}>
            <Table.Cell>
                <Popup inverted size="small" position='left center' content='Liste aller Einträge anzeigen' trigger={
                    <a href="#" onClick={() => dispatch(actionCreators.push('storelocator/stores/' + lotteryId))}>
                        {state.state}
                    </a>
                } />
            </Table.Cell>
            <Table.Cell>
                {(storelocatorDetails !== null)?moment(storelocatorDetails['last-import']).fromNow():'-'}
            </Table.Cell>
            <Table.Cell textAlign="center">
                <Popup inverted size="small" position='top center' content='Liste aller gültigen Stores anzeigen' trigger={
                    <a href="#" onClick={() => dispatch(actionCreators.push('storelocator/stores/' + lotteryId + '/valid'))}>{(storelocatorDetails !== null)?(storelocatorDetails['count']['geocode'] || 0):0}</a>
                } />
            </Table.Cell>
            <Table.Cell textAlign="center">
                 <Popup inverted size="small" position='top center' content='Liste aller Stores anzeigen, für die keine passende Location über die Google Location API gefunden wurde' trigger={
                    <a href="#" onClick={() => dispatch(actionCreators.push('storelocator/stores/' + lotteryId + '/missing_geocode'))}>{(storelocatorDetails !== null)?((storelocatorDetails['count']['valid'] || 0) - (storelocatorDetails['count']['geocode'] || 0)):0}</a>
                } />
            </Table.Cell>
            <Table.Cell textAlign="center">
                <Popup inverted size="small" position='top center' content='Liste aller Stores anzeigen, für die keine gültige Adresse aus den Rohdaten extrahiert werden konnte' trigger={
                    <a href="#" onClick={() => dispatch(actionCreators.push('storelocator/stores/' + lotteryId + '/missing_address'))}>{(storelocatorDetails !== null)?((storelocatorDetails['count']['missing_id'] || 0) + (storelocatorDetails['count']['missing_address'] || 0)):0}</a>
                } />
            </Table.Cell>
            <Table.Cell textAlign="center">
                <Popup inverted size="small" position='top center' content='Liste aller gesperrten Einträge anzeigen' trigger={
                    <a href="#" onClick={() => dispatch(actionCreators.push('storelocator/stores/' + lotteryId + '/item_on_blacklist'))}>{(storelocatorDetails !== null && typeof storelocatorDetails['count']['item_on_blacklist'] !== 'undefined')?storelocatorDetails['count']['item_on_blacklist']:0}</a>
                } />
            </Table.Cell>
            <Table.Cell>
                {
                    (isUploading.loading || isUploading.success || isUploading.error || isUploading.processing)?
                        (isUploading.loading)?
                            <div><Loader active inline size='mini' /> Übertrage Datei</div>
                        :
                            (isUploading.error)?
                                <div><Icon color='red' name='delete' />Fehler beim Upload</div>
                            :
                                (isUploading.processing)?
                                    <div><Loader active inline size='mini' /> Verarbeite Daten</div>
                                :
                                    <div><Icon color='green' name='checkmark' />Upload abgeschlossen</div>
                    :
                    <Dropzone onDrop={(files) => onDrop(lotteryId, files)}>
                    {({getRootProps, getInputProps}) => (
                        <Button icon labelPosition="left">
                            <Icon name='upload' />
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <p>Datei auswählen...</p>
                            </div>
                        </Button>
                    )}
                    </Dropzone>
                }
            </Table.Cell>
        </Table.Row>
    )
}